// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea-module--textarea--K64BJ"};